var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.payload)?_c('HeroBanner',_vm._b({attrs:{"promoLink":_vm.config.promoLink,"productMetadata":_vm.config.productMetadata}},'HeroBanner',_vm.payload,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }